module.exports = __webpack_public_path__ + "img/6015.d8ad41fc.png";